import angular from 'angular';

class editRoleCtrl {
  constructor($scope, httpRequest, $state, $stateParams, formvalidateApi) {
    $scope.roleForm = {
      specialTag: '0',
    };
    const { roleId } = $stateParams;

    $scope.isEdit = roleId ? true : false;

    // 机构
    $scope.userType = JSON.parse(localStorage.user_info).user.userType;
    $scope.queryOrgConfig = {
      queryName: 'orgName',
      queryKey: 'orgId',
      queryType: 'statistTree',
      parentIdName: 'parentOrgId',
      multiple: false,
      parentId: -1,
      defaultSelect: [],
    };
    //机构树的check配置信息
    $scope.config = {
      check: {
        enable: true, //显示不显示复选框
        chkboxType: { Y: '', N: '' },
        chkStyle: 'radio',
        radioType: 'all',
      },
    };
    const userTypeOrgCtrl = {
      0: {
        mapper() {
          const userIsEditState = {
            true: {
              mapper() {
                $scope.currentOrg = {
                  orgId: $stateParams.orgId == -1 ? -2 : $stateParams.orgId,
                };
              },
            },
            false: {
              mapper() {
                $scope.currentOrg = sessionStorage.rolePageOrg
                  ? JSON.parse(sessionStorage.rolePageOrg)
                  : [];
              },
            },
          };
          userIsEditState[$scope.isEdit].mapper();
          $scope.defaultOrg = $scope.currentOrg;
          httpRequest.get_organization(0).then((res) => {
            $scope.orgList = res.data.value;
            $scope.orgList.unshift({
              orgId: -2,
              orgName: '全部机构',
              parentOrgId: -1,
              treeLevelCode: '0',
            });
            $scope.nodeCtrl($scope.orgList);
            for (let item of $scope.orgList) {
              // 如果是独享specialTag == 1 则显示全部机构
              if ($scope.roleForm.specialTag === '1' && item.orgId === -2) {
                $scope.queryOrgConfig.defaultSelect = [item];
                $scope.selectedOrgList = [item];
                break;
              }
              if (item.orgId == $scope.defaultOrg.orgId) {
                $scope.queryOrgConfig.defaultSelect = [item];
                $scope.selectedOrgList = [item];
                break;
              }
            }
          });
        },
        name: 'admin',
      },
      1: {
        mapper() {
          $scope.currentOrg = {
            orgId: JSON.parse(localStorage.user_info).user.currentOrgId,
          };
          httpRequest
            .get_organization(
              JSON.parse(localStorage.user_info).user.orgOwnership
            )
            .then((res) => {
              $scope.orgList = res.data.value;
              $scope.nodeCtrl($scope.orgList);
              for (let item of $scope.orgList) {
                if (item.orgId == $scope.currentOrg.orgId) {
                  $scope.queryOrgConfig.defaultSelect = [item];
                  $scope.selectedOrgList = [item];
                  break;
                }
              }
            });
        },
        name: '非admin',
      },
    };
    userTypeOrgCtrl[$scope.userType].mapper();
    // 节点的配置
    $scope.nodeCtrl = function (orgList) {
      angular.forEach(orgList, function (item) {
        item.open = true;
        item.checked = false;
      });
    };
    const buildTree = function (list) {
      // 适配树组件数据结构
      function recursion(data, pid) {
        const result = [];
        let temp;
        for (const i in data) {
          if (data[i].parentFunctionId == pid) {
            result.push(data[i]);
            temp = recursion(data, data[i].functionId);
            if (temp.length > 0) {
              data[i].children = temp;
            }
          }
        }
        return result;
      }
      return recursion(list, -1);
    };
    const getSelectedItem = function (treeData) {
      // 递归树 获取选中项返回展平数组
      const result = [];
      var recursionTree = function (nodes, cb) {
        for (let i = 0; i < nodes.length; i++) {
            cb(nodes[i])
            if (nodes[i].childFuncList) {
                recursionTree(nodes[i].childFuncList, cb)
            }
        }
        // for (const i in nodes) {
        //   cb(nodes[i]);
        //   if (nodes[i].childFuncList) {
        //     recursionTree(nodes[i].childFuncList, cb);
        //   }
        // }
      };
      recursionTree(treeData, (item) => {
        if (item.selected == true) {
          result.push(item.functionId);
        }
      });
      return result;
    };
    const setSelectedItem = function (treeData, selectedItems) {
      // 递归树 比较选中项目 设置 selected
      var recursionTree = function (nodes, cb) {
        for (const i in nodes) {
          cb(nodes[i]);
          if (nodes[i].childFuncList) {
            recursionTree(nodes[i].childFuncList, cb);
          }
        }
      };
      recursionTree(treeData, (item) => {
        for (const i in selectedItems) {
          if (item.functionId == selectedItems[i]) {
            item.selected = true;
          }
        }
      });
    };

    $scope.validateRules = {
      roleName: [
        {
          erromsg: '角色名称不得超过20个字符',
          condition(value) {
            return value && value.length > 20;
          },
        },
      ],
      remark: [
        {
          erromsg: '角色描述不得超过50个字符',
          condition(value) {
            return value && value.length > 50;
          },
        },
      ],
    };

    function getFunctionList(orgId) {
      // httpRequest.get_enableFunctionList()
      if (orgId === -2) {
        orgId = ''; // 全部机构->查租户功能包，不传orgId
      }
      const loadingLogo = window.layer.msg('正在加载...', {
        time: 0,
        skin: 'layer-loading-self',
        icon: 16,
        shade: 0.5,
      });
      httpRequest
        .get_orgEnableFunctionList(orgId)
        .then((res) => {
          // 机构树
          // 如果有 选中角色  $scope.roleForm.functionIdList
          if ($scope.currentOrg.orgId != -2 && !$scope.isEdit) {
            isSpecialTag(res.data.value, $scope.roleForm.specialTag);
          } else {
            $scope.fnTree = buildTree(res.data.value);
          }
          roleId &&
            httpRequest.get_permissionRoleInfo(roleId).then((res) => {
              $scope.roleForm = res.data.value;
              // const { functionIdList } = $scope.roleForm
              $scope.functionIdList = $scope.roleForm.functionIdList;
              $scope.isOrNotSpecialTag = $scope.roleForm.specialTag;
              isSpecialTag($scope.fnTree, $scope.isOrNotSpecialTag);
              setSelectedItem($scope.fnTree, $scope.functionIdList);
            });
        })
        .finally(() => {
          window.layer.close(loadingLogo);
        });
    }
    getFunctionList($scope.currentOrg.orgId);
    // 如果非独享角色 过滤系统设置模块的数据
    function isSpecialTag(treeData, isOrNotSpecialTag) {
      if (isOrNotSpecialTag === '0') {
        angular.forEach(treeData, function (item, index) {
          if (item.functionId == 1) {
            let filterData = item.childFuncList.filter((data, index, arr) => {
              return data.functionId !== 5;
            });
            item.childFuncList = filterData;
          }
        });
        $scope.fnTree = buildTree(treeData);
      }
    }
    $scope.submit = function () {
      const fnIdList = getSelectedItem($scope.fnTree);
      $scope.roleForm.functionIdList = fnIdList;
      if ($scope.userType == '0' && !$scope.isEdit) {
        if (!$scope.currentOrg) {
          logger.logError('请选择所属机构');
          return;
        }
        $scope.roleForm.orgId = $scope.currentOrg.orgId;
      }
      const mark = formvalidateApi.run();
      if (!mark) {
        return;
      }
      if (roleId) {
        httpRequest
          .post_permissionRoleInfo($scope.roleForm, '角色信息修改成功')
          .then(() => {
            $state.go('system.permission.role.list');
          });
      } else {
        httpRequest
          .add_permissionRole($scope.roleForm, '新增角色成功')
          .then(() => {
            $state.go('system.permission.role.list');
          });
      }
    };
    // 点击取消跳转
    $scope.cancel = function () {
      $state.go('system.permission.role.list');
    };

    // 机构变化
    $scope.orgSelectChange = function orgSelectChange(orgList) {
      $scope.currentOrg = orgList[0];
      // 如果勾选独享角色并切换非全部机构设置默认值
      if ($scope.currentOrg.orgId != -2) {
        $scope.roleForm.specialTag = '0';
      }
      $scope.showSysSetting = false;
      // 设置组件单选
      $scope.queryOrgConfig.defaultSelect = orgList;
      // 角色所属机构字段
      $scope.roleForm.orgId = orgList[0].orgId;
      // 换功能包
      getFunctionList(orgList[0].orgId);
    };
  }
}
editRoleCtrl.$inject = [
  '$scope',
  'httpRequest',
  '$state',
  '$stateParams',
  'formvalidateApi',
];
export default editRoleCtrl;



// WEBPACK FOOTER //
// ./src/app/system/permission/role/editRoleCtrl.js